
class CapViewOneTimeRide {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_one_time_ride'
}

function create(config) {
  return new CapViewOneTimeRide(config)
}

export default {
  key,
  create,
}
